<template>
  <div>
    <el-card shadow="hover">
      <div slot="header">
        Motif size distribution 
        <span style="opacity: 0">
          <el-button disabled style="cursor: default" circle icon="el-icon-top-right" size="mini" @click="handleModalOpen"></el-button>
        </span>
      </div>
      <div style="height: 35vh; width: 96%; margin-left: 2%; min-height: 300px">
        <IEcharts :resizable="true" theme="vintage" :option="pieOptions" v-if="pieOptions !== null"/>
      </div>
    </el-card>
  </div>
</template>

<script>
  import 'echarts/theme/vintage.js'
  import { store } from '../scripts/store.js'
  import { events } from '../scripts/events.js'
  import IEcharts from 'vue-echarts-v3/src/full.js';
  const _ = require('lodash');

  export default {
    name: 'MainPlotPieDistribution',
    props: {
      info: Object,
      index: Number
    },
    components: { IEcharts },
    asyncComputed: {
      pieOptions: function () {
        const plotdata = this.info.RepInfo.PlotData;
        const repeats = Object.keys(plotdata);
        const classes = ['Mono', 'Di', 'Tri', 'Tetra', 'Penta', 'Hexa'];
        let series = [{
            type: 'pie',
            data: classes.map(d => {return {name: d, value: 0}}),
            radius: ['40%', '70%'],
            center: ['50%', '60%'],
            label: { normal: { show: false } },
            labelLine: { normal: { show: false } }
        }];
        repeats.forEach(rep => { series[0].data[rep.length - 1].value += _.sum(_.flatten(Object.values(plotdata[rep]))); })

        const options = {
            backgroundColor: 'white', 
            tooltip: {
                backgroundColor: 'rgba(240, 240, 240, 0.8)',
                textStyle: {
                    align: 'left',
                    color: 'rgba(50, 50, 50, 0.8)'
                }
            },
            grid: { top: 100 },
            toolbox: {
              right: 20,
              feature: {
                saveAsImage: { 
                  title: 'Save as PNG',
                  show: true, 
                  type: 'png', 
                  name: `${this.info.OrgInfo.OrganismName}_kmerDistribution` 
                },
                dataView: { 
                  title: 'View data', 
                  readOnly: true, 
                  lang: ['Data View', 'Go back'] 
                },
              },
              top: -5
            },
            legend: {
                textStyle: { color: 'black' },
                show: true,
                top: 25
            },
            series: series,
            animation: true,
        }
        return new Promise(resolve => setTimeout(() => resolve(options), this.index * store.settings.plotUpdateDelayFactor))
      }
    },
    methods: {
      handleModalOpen: function () {
        events.$emit('open-modal', 'ModalPieDistribution')
      }
    }
  }
</script>